import { render } from "./complAbout.vue?vue&type=template&id=5e2ea01c&scoped=true"
import script from "./complAbout.vue?vue&type=script&lang=js"
export * from "./complAbout.vue?vue&type=script&lang=js"

import "./complAbout.vue?vue&type=style&index=0&id=5e2ea01c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2ea01c"]])

export default __exports__